/**
 * useNavPrefs — the user's sidebar customization (which pages show, in
 * what order), shared shape with the GAS dashboard via @techstack/core.
 *
 * The two-tier storage, the optimistic save and the per-tab subscriber list
 * all live in [[createPrefsStore]] now — this file is the sidebar's two names
 * and nothing else. It moved there when the account tab strip wanted the same
 * mechanics against a different `preference_type`; see that file for why both
 * tiers are load-bearing.
 */

import { normalizeNavPrefs } from '@techstack/core';
import createPrefsStore from './createPrefsStore';

export const NAV_PREFS_TYPE = 'nav_layout';
const LOCAL_KEY = 'tekstak.navPrefs';

const store = createPrefsStore({
  type: NAV_PREFS_TYPE,
  localKey: LOCAL_KEY,
  normalize: normalizeNavPrefs,
});

/** Is there a session to sync against? Signed out, local-only is all there is. */
export const hasNavPrefsAccount = store.hasAccount;

export const useNavPrefs = store.usePrefs;

export default useNavPrefs;
